import React, { useEffect, useState } from "react";
import rehypeRaw from "rehype-raw";
import { format } from "date-fns";
import logo from "../../assets/images/logo.png";
import { useLocation, useParams } from "react-router-dom";
import { handleGetBlogBySlug } from "../../service/service";
import { BlogType } from "../../types/types";
import PrimaryButton from "../common/PrimaryButton";
import { GoMail } from "react-icons/go";
import Markdown from "react-markdown";
import {
  MdOutlineAccessTime,
  MdOutlineLocationOn,
  MdPhoneInTalk,
} from "react-icons/md";
import { RiInstagramFill } from "react-icons/ri";
import { FaLinkedin, FaUserLarge } from "react-icons/fa6";
import { FaFacebook } from "react-icons/fa";

const DetailedBlogPage = ({
  setIsOpen,
}: {
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const location = useLocation();
  const { slug } = useParams<{ slug: string }>();
  const [blog, setBlog] = useState<BlogType | null>(null);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    const getCaseStudy = async () => {
      try {
        setLoading(true);
        const data = await handleGetBlogBySlug(slug || "");
        setBlog(data.data as BlogType);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.error("Error fetching blog:", error);
      } finally {
        setLoading(false);
      }
    };

    if (location.state !== null) {
      setBlog(location?.state?.blog as BlogType);
    } else {
      getCaseStudy();
    }
  }, [slug, location, location.pathname]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!blog) {
    return (
      <div className="w-full pt-28 mt-10 flex justify-center items-center">
        Blog not found.
      </div>
    );
  }

  let url = "https://admin.techqilla.com";

  const heading1 = blog.title.split(" ")[0];
  const heading2 = blog.title.split(" ").slice(1).join(" ");

  return (
    <div className="relative jost-regular flex w-full justify-center items-center max-w-screen-2xl mx-auto">
      <div className="flex flex-col justify-center items-center w-full mb-10">
        <div className="hidden absolute sm:flex flex-wrap justify-between px-6 text-white items-center top-0 w-full bg-black bg-opacity-60">
          <div className="flex flex-wrap">
            <div className="flex justify-center group cursor-pointer items-center py-4">
              <GoMail className="text-3xl group-hover:-translate-y-1 transition-all duration-300 text-white mx-4" />
              <a href="mailto:laila.khan@psycheethos.com">
                laila.khan@psycheethos.com
              </a>
            </div>
            <div className="w-[1px] h-16 bg-white bg-opacity-20 ml-4"></div>
            <div className="flex justify-center group cursor-pointer items-center py-4">
              <MdPhoneInTalk className="text-3xl group-hover:-translate-y-1 transition-all duration-300 text-white mx-4" />
              <p onClick={() => window.open("tel:+447796958622")}>
                +447796958622
              </p>
            </div>
            <div className="w-[1px] h-16 bg-white bg-opacity-20 ml-4"></div>
            <div className="flex justify-center group cursor-pointer items-center py-4">
              <MdOutlineLocationOn className="text-3xl group-hover:-translate-y-1 transition-all duration-300 text-white mx-4" />
              <p>71-75 Shelton Street Covent Garden, London WC2 9JQ U.K.</p>
            </div>
          </div>
          <div className="flex group flex-wrap">
            <div className="flex justify-center items-center py-3">
              <MdOutlineAccessTime className="text-3xl group-hover:-translate-y-1 transition-all duration-300 text-white mx-4" />
              <p>Mon-Fri:10am-4pm</p>
            </div>
            <div className="w-[1px] h-16 bg-white bg-opacity-20 ml-4"></div>
            <div className="flex justify-center gap-4 items-center py-3 mx-8">
              <div className="p-1 cursor-pointer border rounded-full w-10 h-10 hover:-translate-y-1 transition-all duration-300 flex justify-center items-center">
                <RiInstagramFill className="text-2xl text-white" />
              </div>
              <div className="p-1 cursor-pointer border rounded-full w-10 h-10 hover:-translate-y-1 transition-all duration-300 flex justify-center items-center">
                <FaLinkedin className="text-2xl text-white" />
              </div>
              <div className="p-1 cursor-pointer border rounded-full w-10 h-10 hover:-translate-y-1 transition-all duration-300 flex justify-center items-center">
                <FaFacebook className="text-2xl text-white" />
              </div>
            </div>
          </div>
        </div>
        <div className="flex mt-12 justify-between px-0 sm:px-20 pt-4 text-white items-center md:top-32 xl:top-20 w-full">
          <div className="w-full">
            <img src={logo} className="h-20" alt="" />
          </div>
          <div className="hidden sm:block">
            <PrimaryButton
              onClick={() => setIsOpen(true)}
              className="w-[300px] uppercase"
              icon
            >
              Book a Consultation
            </PrimaryButton>
          </div>
        </div>

        <div className="w-full flex justify-between items-center jost-regular pt-6 sm:pt-20 pb-6">
          <div className="flex flex-col flex-wrap gap-5 px-6 sm:px-20">
            <h1 className="text-2xl sm:text-6xl font-semibold">
              Blog and Articles
              <span className="text-2xl sm:text-6xl italic ml-2 font-eiko-thin">
                from mindio
              </span>
            </h1>
            <p>Connecting people – how talk can change our lives</p>
          </div>
        </div>
        <div className="w-full flex items-center justify-center">
          <div className="mx-4 sm:mx-20 rounded-t-3xl overflow-hidden">
            <img
              src={`${url}${blog.cover.url}`}
              className="min-w-[1200px]"
              alt=""
            />
            {/* <div className="flex flex-wrap jost-regular justify-between items-center py-4 px-8 bg-secondary rounded-b-3xl text-white"> */}
            {/*   <div> */}
            {/*     <div className="flex justify-center gap-4 items-center py-3 sm:mx-8 mt-4 sm:mt-0"> */}
            {/*       <div className="p-1 cursor-pointer border rounded-full w-10 h-10 hover:-translate-y-1 transition-all duration-300 flex justify-center items-center"> */}
            {/*         <RiInstagramFill className="text-2xl text-white" /> */}
            {/*       </div> */}
            {/*       <div className="p-1 cursor-pointer border rounded-full w-10 h-10 hover:-translate-y-1 transition-all duration-300 flex justify-center items-center"> */}
            {/*         <FaLinkedin className="text-2xl text-white" /> */}
            {/*       </div> */}
            {/*       <div className="p-1 cursor-pointer border rounded-full w-10 h-10 hover:-translate-y-1 transition-all duration-300 flex justify-center items-center"> */}
            {/*         <FaFacebook className="text-2xl text-white" /> */}
            {/*       </div> */}
            {/*     </div> */}
            {/*   </div> */}
            {/* </div> */}

            <div className="flex flex-wrap gap-5 pt-4 mb-10">
              <div>
                <div className="bg-secondary px-8 py-4 text-white mt-3 mr-3 hover:bg-white hover:text-primary transition rounded-lg flex flex-col items-center duration-500 ease-in-out">
                  <div className="text-3xl font-bold">
                    {format(new Date(blog.publishedAt), "dd")}
                  </div>
                  <div className="text-xl">
                    {format(new Date(blog.publishedAt), "MMM")}
                  </div>
                </div>
              </div>
              <div className="flex flex-col justify-between">
                <h1 className="text-2xl sm:text-6xl">
                  {heading1}
                  <span className="text-2xl ml-2 sm:text-6xl italic font-eiko-thin">
                    {heading2}
                  </span>
                </h1>

                <div className="flex">
                  <FaUserLarge className="text-[#8E8E8E] text-xl" />
                  <p className="text-base ml-2 opacity-50">
                    {blog.psyche_author.name}
                  </p>
                </div>
              </div>
            </div>

            <Markdown rehypePlugins={[rehypeRaw]}>{blog.content}</Markdown>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailedBlogPage;
